<template>
  <section class="overview" v-show="ready">
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow">
        My Dashboard&nbsp;
      </h1>
      <overview-card
        class="mt-3"
        :available-workshops="activeLessons"
        :completed-lessons="completedLessons"
        :active-classes="activeClasses"
      />
      <badges v-if="useBadges && auth" />
      <v-card class="my-4" v-if="todoList && todoList.length">
        <v-toolbar color="primary" flat dark>
          <v-toolbar-title>To do list</v-toolbar-title>
        </v-toolbar>
        <v-row
          no-gutters
          justify="space-between"
          class="to-do-row"
          v-for="(todo, key) in todoList"
          :key="key"
        >
          <v-col cols="12" md="8" v-if="todo.in_progress == 0">
            You have to start {{ todo.lesson }} on class
            {{ todo.class_name }}
          </v-col>
          <v-col cols="12" md="8" v-else>
            You have started {{ todo.lesson }} on class {{ todo.class_name }}
          </v-col>
          <v-col cols="12" md="4">
            <v-btn
              block
              color="secondary"
              class="primary--text"
              @click="startLesson(todo)"
            >
              {{
                todo.in_progress == 0
                  ? `click here to start ${lessonTerm}`
                  : `click here to continue ${lessonTerm}`
              }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-row v-if="auth" class="mb-4">
        <v-col cols="12">
          <result-overview @loaded="quizLoaded = true" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import ResultOverview from '@/modules/auth/views/results/ResultOverview'
import Badges from '@/modules/badge/views/Badges'
import Auth from '@/modules/auth/models/Auth'
import Student from '@/modules/student/models/Student'
import UserLesson from '@/modules/lesson/models/UserLesson'
import Lesson from '@/modules/lesson/models/Lesson'
import OverviewCard from '@/modules/auth/views/dashboard/OverviewCard'
import { mapState } from 'vuex'

export default {
  name: 'Overview',
  components: {
    /*     BarChart, */
    ResultOverview,
    Badges,
    OverviewCard
  },
  data() {
    return {
      todoList: [],
      loaded: false,
      quizLoaded: false
    }
  },
  async mounted() {
    this.$store.state.loading = true
    let list = await Student.dispatch('todoList')
    for (let i = 0; i < list.length; i++) {
      if (this.getLessonSlides(list[i].lesson).length) {
        this.todoList.push(list[i])
      }
    }
    // this.todoList = await Student.dispatch('todoList')

    await Auth.dispatch('me', 'students')
    this.loaded = true
  },
  watch: {
    ready(val) {
      if (val) {
        this.$store.state.loading = false
      }
    }
  },
  computed: {
    ...mapState(['bucketUrl', 'useBadges', 'lessonTerm']),
    activeLessons() {
      if (Auth.query().first())
        return Auth.query().first().student_meta.assigned_lessons
      return 0
    },
    completedLessons() {
      if (Auth.query().first())
        return Auth.query().first().student_meta.completed_lessons
      return 0
    },
    activeClasses() {
      return this.$store.getters['entities/classes/query']().count()
    },
    authStudent() {
      const authStudent = this.$store.getters['entities/auths/query']().first()
      return authStudent
    },
    userLesson() {
      return UserLesson.all()
    },
    auth() {
      return Auth.query().first()
    },
    ready() {
      if (this.loaded && this.quizLoaded) {
        return true
      }
      return false
    }
  },
  methods: {
    getLessonSlides(lessonName) {
      let lessons = Lesson.query()
        .where('name', lessonName)
        .get()
      return lessons.length ? lessons[0].lesson_slides : []
    },
    async startLesson(todo) {
      if (!todo.user_lesson_id) {
        const payload = {
          customClassId: todo.custom_class_id,
          slug: todo.lesson_slug
        }

        try {
          const userLesson = await Student.dispatch('startClassLesson', {
            payload: payload
          })
          this.redirectToLesson(userLesson.id, userLesson.lesson.slug)
        } catch (error) {
          if (error.status === 422) {
            if (
              error.data.message ===
              'Lesson in progress for this class and this student.'
            ) {
              this.redirectToLesson(todo.user_lesson_id, todo.lesson_slug)
            }
          }
        }
      } else {
        this.redirectToLesson(todo.user_lesson_id, todo.lesson_slug)
      }
    },
    redirectToLesson(userLessonId, slug = '') {
      let link = ''
      let base_url = window.location.origin
      if (process.env.NODE_ENV === 'production') {
        link = 'lessons/'
      } else {
        base_url = process.env.VUE_APP_LESSON
      }

      window.open(
        // `${base_url}/${link}?slug=${slug}&user_lesson_id=${userLessonId}`
        `${base_url}/${link}student/?slug=${slug}&user_lesson_id=${userLessonId}`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.overview {
  .main {
    display: block;
    width: 100%;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;

    h2 {
      font-size: 30px;
      padding: 0;
      margin: 0;
      font-weight: normal;
    }

    h3 {
      font-size: 30px;
      font-weight: normal;
    }

    .analytics {
      text-align: center;

      .figure {
        font-size: 100px;
        padding: 0;
        max-width: 0;
        line-height: 140px;
      }
      .label {
        padding: 0;
        font-size: 18px;
      }
    }
  }

  .to-do-row {
    border-bottom: 1px solid #ccc;
    padding: 15px;
    margin: 0;
    overflow: auto;
  }
}
</style>
